module.exports = __webpack_public_path__ + "img/sms-flash.0fbe96bc.svg";